module.exports = __webpack_public_path__ + "static/media/Chevron_circular.525a7a47.svg";